import script from "./GmxTableNew.vue?vue&type=script&setup=true&lang=js"
export * from "./GmxTableNew.vue?vue&type=script&setup=true&lang=js"

import "./GmxTableNew.vue?vue&type=style&index=0&id=e6acdbc2&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e6acdbc2"]])

export default __exports__